import React from 'react';
import { Route, Switch } from 'react-router';
import ContactView from './scenes/View';

const ContactRouter = ({ match }) => {
  return (
    <Switch>
      <Route path='/dashboard/crm/contacts/:id' exact component={ContactView} />
    </Switch>
  );
};

export default ContactRouter;
